<template>
  <div>
    <p>Inspect message details to troubleshoot problems in your system:</p>
    <ul>
      <li><strong>Message headers</strong> - View all metadata including timestamps, correlation IDs, and custom headers</li>
      <li><strong>Message body</strong> - Examine the full payload content of each message</li>
      <li><strong>Processing details</strong> - See which endpoint processed the message and when</li>
      <li><strong>Header Search</strong> - Quickly find specific message headers</li>
    </ul>
  </div>
</template>
